// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__1xZjD","list":"FieldCheckboxGroup_list__oXasR","twoColumns":"FieldCheckboxGroup_twoColumns__2z3Qk","item":"FieldCheckboxGroup_item__Y-EaG"};